import { createContext } from 'react';
import Config from '../../domain/entities/Config';

const ConfigContext = createContext<Config | {}>({});

export default ConfigContext;
